<template>
  <div class="container1">
    <div class="main_con">
      <div class="top">
        <div class="top_left" @click="gaback">
          <van-icon name="arrow-left" />
        </div>
        <div class="top_center">{{ cardItem.medalTypeName }}</div>
        <div class="topRight"></div>
      </div>
      <div class="info_left1" >
        <img :src="$store.state.userInfo.icon" alt="" />
        <div class="info_base">
          <div>{{ $store.state.userInfo.nickname }}</div>
          <div>{{ $store.state.userInfo.position }}</div>
        </div>
      </div>
      <div class="swiper_con">
        <swiper class="scrollItem" :options="swiperOptions" style="width: 100%">
          <swiper-slide v-for="(item, index) in badgeList" :key="index">
            <div class="img_con">
              <img
                :src="imgUrl + (item.light == 1 ? item.iconId : item.fileId)"
                alt=""
              />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="title_con">
        <img class="img_con" src="@/assets/newMedal/time/timeLeft.png" alt="" />
        <div class="title_name">{{ badgeList[activeIndex]?.medalName }}</div>
        <img
          class="img_con"
          src="@/assets/newMedal/time/timeRight.png"
          alt=""
        />
      </div>
      <div class="remark_con">
        <div class="top_con">恭喜获得“雷士照明公益{{ badgeList[activeIndex]?.unlockDuration }}小时徽章”</div>
        <div class="buttom_con">
          已解锁：<span style="color: #22ba98">{{light.length}}</span>/{{ badgeList.length }}枚
        </div>
      </div>
      <!-- <div class="timeTitle" v-if="badgeList[activeIndex]?.getTime">
        于{{ badgeList[activeIndex]?.getTime }}点亮勋章
      </div> -->
      <div class="check_con">
        <el-button @click="toDetail(badgeList[activeIndex])"
          >查看详情</el-button
        >
      </div>
      <div class="logo">
        <!-- <img src="../../../../assets/newMedal/time/logo.svg" alt="" /> -->
      </div>
    </div>
    <van-dialog
      class="dialog"
      v-model="showUnlock"
      :showConfirmButton="false"
      z-index="1999"
    >
      <div class="dialog-people">解锁说明：</div>
      <div class="dialog-reason">
        <div>
          <van-field
            v-model="unlockExplain"
            rows="3"
            autosize
            type="textarea"
            readonly
            show-word-limit
          />
        </div>
      </div>
      <div class="dialog-btn">
        <el-button @click="cancelBtn">取消</el-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import api from "@/apis/medal";
import moment from "moment";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    let _this = this;
    return {
      activeIndex: 0,
      swiperOptions: {
        loop: true,
        // autoplay: false,
        loopedSlides: 0,
        loopAdditionalSlides: 0,
        slidesPerView: "auto",
        effect: "coverflow",
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -10,
          depth: 290,
          modifier: 1,
          slideShadows: false
        },
        on: {
          init: function () {
            _this.cardItem = JSON.parse(localStorage.getItem("cardItem"));
            _this.badgeItem = JSON.parse(localStorage.getItem("badgeItem"));
            const nameIndex = _this.cardItem.medals.findIndex(
              item => item?.medalName == _this.badgeItem?.medalName
            );
            _this.activeIndex = this.realIndex;
            this.activeIndex = nameIndex;
            _this.activeIndex = nameIndex;
          },
          slideChange: function () {
            _this.activeIndex = this.realIndex;
          }
        }
      },
      badgeList: [],
      imgUrl: "",
      cardItem: {},
      badgeItem: {},
      titleList: [],
      showUnlock: false,
      unlockExplain: "",
      light:[]
    };
  },
  created() {
    this.imgUrl = api.imgUrl;
    this.cardItem = JSON.parse(localStorage.getItem("cardItem"));
    this.badgeItem = JSON.parse(localStorage.getItem("badgeItem"));
    this.cardItem.medals.length > 0 && this.cardItem.medals.forEach(item => {
      if(item.light == 1){
        this.light.push(item)
      }
    })
  },
  mounted() {
    //获取徽章列表
    this.badgeList = this.cardItem.medals.map(item => {
      item.year = item.medalName?.match(/\d+/);
      item.getTime = item.getTime
        ? moment(item.getTime).format("YYYY/MM/DD")
        : "";
      return item;
    });
    //排序徽章列表
    this.badgeList = this.badgeList.sort((a, b) => a.companyAge - b.companyAge);
  },
  methods: {
    changeSlid() {},
    changeSlid1() {},
    // 返回上一页
    gaback() {
      localStorage.setItem("tabValue", JSON.stringify(this.cardItem.id));
      this.$router.back();
    },
    //跳转徽章详情
    toDetail(info) {
      if (info?.light == 1) {
        this.$router.push({
          path: "/mobile/medal/publicWelfare/benefitDetail",
          query: {
            id: info?.recordId
          }
        });
      } else {
        return this.$message({
          type: "warning", // success error warning
          message: "您还未获取该周年卡！",
          duration: 2000
        });
      }
      // localStorage.setItem("publicWelfareActive", 1);
    },
    //解锁说明
    handleDetailUnlock() {
      this.unlockExplain = this.badgeList[this.activeIndex].unlockDescribe;
      this.showUnlock = true;
    },
    // 关闭解锁说明弹窗
    cancelBtn() {
      this.showUnlock = false;
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.container1 {
  width: 100%;
  height: 100%;
  background: url("~@/assets/newMedal/time/time3.png");
  background-size: 100% 100%;
  position: relative;
}
.container2 {
  width: 100%;
  height: 100%;
  background: url("~@/assets/newMedal/time/time2.png");
  background-size: 100% 100%;
  position: relative;
}
.main_con {
  padding-top: 1px;
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 30px;
  color: #fff;
  margin: 30px;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top_center {
    // margin-left: -15%;
  }
}
.info_left1 {
  display: flex;
  align-items: center;
  position: absolute;
  top: 10%;
  left: 6%;
  img {
    width: 75px;
    height: 75px;
    border: 5px solid #fff;
    border-radius: 50%;
  }
  .info_base {
    font-size: 26px;
    color: #fff;
    margin-left: 20px;
    div:nth-child(1) {
      color: #fff;
      font-size: 29px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    div:nth-child(2) {
      color: #999999;
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 15px;
    }
  }
}
.swiper_con {
  position: absolute;
  top: 16vh;
  width: 100%;
  // margin-top: 7vh;
  .scrollItem {
    width: 100% !important;
    height: 400px;
  }
  .swiper-slide {
    width: 400px;
    display: flex;
    justify-content: center;
  }
  .swiper-slide-active {
    .img_con {
      opacity: 1 !important;
    }
  }
  .img_con {
    width: 400px;
    height: 400px;
    opacity: 0.2;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.title_con {
  width: 100%;
  position: absolute;
  top: 55vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .img_con {
    width: 33px;
    height: 58px;
  }
  .title_name {
    color: #ffffff;
    font-weight: 600;
    font-size: 48px;
    min-width: 320px;
    text-align: center;
  }
}
.remark_con {
  width: 100%;
  position: absolute;
  top: 65vh;
  .top_con {
    color: #999999;
    font-size: 32px;
    text-align: center;
    margin-bottom: 10px;
  }
  .buttom_con {
    color: #666666;
    font-size: 29px;
    text-align: center;
  }
}

.timeTitle {
  width: 100%;
  position: absolute;
  top: 78vh;
  display: flex;
  justify-content: center;
  color: #ffffff;
  font-size: 22px;
}
.check_con {
  width: 100%;
  position: absolute;
  bottom: 9vh;
  display: flex;
  justify-content: center;
  ::v-deep {
    .el-button {
      width: 400px;
      height: 80px;
      color: #fff;
      background: #008755;
      font-size: 36px;
      border-radius: 40px;
      border-color: #008755;
    }
  }
}
.logo {
  position: absolute;
  bottom: 3vh;
  left: 50%;
  transform: translateX(-50%);
}
.dialog {
  height: 190px * $zoom;
  padding: 30px;

  .dialog-people {
    margin-bottom: 30px;
  }

  .dialog-reason {
    ::v-deep {
      .van-cell {
        background: rgba(244, 244, 244, 1);
        margin-top: 30px;
        height: 280px;
      }

      .van-field__control {
        height: 200px !important;
      }
    }
  }

  .dialog-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 30px;
    width: 100%;

    button {
      width: 50%;
      height: 80px;
      border-radius: 40px;
      font-size: 28px;
    }
  }
}
</style>
